import axios from 'axios';

const API = 'https://api.carsavenue.com/api';

// Fire-and-forget analytics: record a profile VIEW (detail page opened) or a
// CONTACT interaction (call / WhatsApp tapped) for a provider's listing.
// Anonymous-friendly (no auth header needed); never blocks or breaks the UI.
export const recordListingEvent = (businessId, category, eventType) => {
  if (!businessId) return;
  try {
    axios
      .post(`${API}/listing-view/record`, { businessId, category, eventType })
      .catch(() => {});
  } catch (e) {
    /* ignore */
  }
};
